import React, { useState } from 'react';

const PromoBanner: React.FC = () => {
  const [isVisible, setIsVisible] = useState(true);

  // Calculate banner height for pushing content down
  const bannerHeight = isVisible ? 'h-12 sm:h-14' : 'h-0';

  return (
    <>
      {/* Fixed banner at the very top */}
      {isVisible && (
        <div id="promo-banner" className="fixed top-0 left-0 right-0 z-[1000] bg-[#102A43]">
          <a
            href="https://sales.legisiq.com"
            target="_blank"
            rel="noopener noreferrer"
            className="block relative hover:bg-[#0d1f32] transition-colors cursor-pointer"
            onClick={(e) => {
              // Allow the link to work but also handle the close button
              if ((e.target as HTMLElement).closest('button')) {
                e.preventDefault();
                e.stopPropagation();
              }
            }}
          >
            <div className="container mx-auto px-2 sm:px-4 py-2 sm:py-3">
              <div className="flex items-center justify-between gap-2 sm:gap-4">
                <div className="flex-1 flex items-center justify-center gap-2 sm:gap-3">
                  <span className="hidden sm:inline-flex items-center px-3 py-1 bg-white/90 rounded-full text-xs font-bold uppercase tracking-wide text-[#102A43]">
                    Limited Time
                  </span>
                  <p className="text-xs sm:text-sm md:text-base font-semibold text-center text-white leading-tight">
                    <span className="font-bold">Save up to $10,000!</span>
                    <span className="hidden sm:inline">
                      {' '}
                      Single states for $300 • All 50 states + federal for just $5,000 (normally
                      $15,000/year)
                    </span>
                    <span className="sm:hidden block mt-1">
                      States from $300 • 50 states + federal $5,000
                    </span>
                  </p>
                </div>
                <button
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    setIsVisible(false);
                  }}
                  className="flex-shrink-0 p-1 hover:bg-white/20 rounded transition-colors text-white z-10"
                  aria-label="Close banner"
                >
                  <svg
                    className="w-4 h-4 sm:w-5 sm:h-5"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                </button>
              </div>
            </div>
          </a>
        </div>
      )}

      {/* Spacer to push down the header and content */}
      <div className={`${bannerHeight} transition-all duration-300`} />
    </>
  );
};

export default PromoBanner;
